module.exports = __webpack_public_path__ + "260ed437360e055a13c9178f5d357c3a.png";